var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('OverlayLoader',{attrs:{"overlay":_vm.overlay,"text":'카카오톡 로그인'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }